import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {GetComparatorAdsService} from './GetComparatorAdsService.js'
import {SaveComparatorAdsService} from './SaveComparatorAdsService.js'

export class UpdateComparatorAdsService extends Service {
  #getComparatorAdsService
  #saveComparatorAdsService

  constructor({getComparatorAdsService, saveComparatorAdsService}) {
    super()
    this.#getComparatorAdsService = getComparatorAdsService
    this.#saveComparatorAdsService = saveComparatorAdsService
  }

  static create() {
    return new UpdateComparatorAdsService({
      getComparatorAdsService: GetComparatorAdsService.create(),
      saveComparatorAdsService: SaveComparatorAdsService.create()
    })
  }

  async #updateComparatorAds({transform}) {
    try {
      const [getAdsError, ads] = await this.#getComparatorAdsService.execute()
      if (getAdsError) return Promise.reject(getAdsError)

      const updatedAds = transform(ads)

      const [saveAdsError, response] = await this.#saveComparatorAdsService.execute({ads: updatedAds})
      return saveAdsError ? Promise.reject(saveAdsError) : response
    } catch (error) {
      return Promise.reject(error)
    }
  }

  @AsyncInlineError()
  async addAd({ad}) {
    return this.#updateComparatorAds({transform: ads => ads.add({ad})})
  }

  @AsyncInlineError()
  async removeAd({adId}) {
    return this.#updateComparatorAds({transform: ads => ads.remove({adId})})
  }
}
